var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3363 0.835938C12.6137 1.59881 9.08242 4.39522 9.25039 8.01976L9.22695 8.03355C8.74648 6.49403 8.0707 5.80928 6.79727 5.12914C5.11758 4.2716 3.29336 5.12914 0.664062 3.41268C2.41445 5.98851 2.41445 9.42601 4.96914 10.2854C6.70742 10.9655 8.53555 10.5657 9.2543 9.94072C10.0863 13.2863 9.96523 16.5997 8.68398 19.9361C8.6332 18.3277 8.24649 16.3608 7.71133 14.9637C7.49258 16.6824 7.63711 19.256 6.17617 20.9747C6.25039 20.1153 5.66445 18.4012 5.08242 17.5418C5.08242 19.256 5.22695 20.9747 4.27773 22.6935H13.6957C13.8988 21.8892 13.977 21.085 14.0473 20.9839C13.7543 21.1999 13.473 21.494 12.9496 21.6089C13.0941 21.6089 13.0395 20.1153 12.9652 19.256C12.3832 20.9747 11.5082 21.8341 10.559 21.8341C11.5785 20.1153 11.434 19.256 11.2895 17.5418C10.7816 19.0308 10.3285 19.8764 9.21133 20.6347C10.684 17.0133 10.848 13.3552 9.96523 9.73392C10.9457 10.2578 12.0512 10.0648 13.2934 8.56664C14.7387 6.82491 13.6605 3.41268 15.3363 0.835938ZM14.0473 20.9839C14.0551 20.9839 14.059 20.9793 14.0629 20.9747C14.059 20.9747 14.0551 20.9793 14.0473 20.9839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNa);
export default __webpack_public_path__ + "static/media/iconNA.319f9d7dd5f17117a0bdc6d84142c04b.svg";
export { ForwardRef as ReactComponent };